import { useMutation } from "react-query";

import URL from "core/resources/urls";
import { httpAgrodrive } from "infra/http";
import { ItemEditForm } from "../types/arquivos";
import config from "infra/config";

export default function useMoveDir() {
  return useMutation(
    [URL.AGRODRIVE.DIRETORIO()],
    async (body: ItemEditForm) => {
      await httpAgrodrive.put(URL.AGRODRIVE.DIRETORIO(), body, {
        headers: {
          "x-api-key": config.agrodriveClientId,
        },
      });
    }
  );
}
